import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import * as CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private _storage: Storage | null = null;
  private _initialized = false;
  private initPromise: Promise<void> | null = null;

  constructor(private storage: Storage) {}

  async init() {
    if (this._initialized) {
      return;
    }

    if (this.initPromise) {
      return this.initPromise;
    }

    this.initPromise = (async () => {
      try {
        await this.storage.defineDriver(CordovaSQLiteDriver);
        this._storage = await this.storage.create();
        this._initialized = true;
      } catch (error) {
        console.error('Error initializing storage:', error);
        throw error;
      }
    })();

    return this.initPromise;
  }

  private async ensureInitialized() {
    if (!this._initialized) {
      await this.init();
    }
  }

  async get<T = any>(key: string): Promise<T | null> {
    await this.ensureInitialized();
    const value = await this._storage?.get(key);
    return value ?? null;
  }

  async set(key: string, value: any) {
    await this.ensureInitialized();
    return this._storage?.set(key, value);
  }

  async delete(key: string) {
    await this.ensureInitialized();
    await this._storage?.remove(key);
  }
}
